import React from 'react';
import styles from './StatWidget.module.css';

interface StatWidgetProps {
    number: string;
    label: string;
    emoji?: string;
}

export const StatWidget: React.FC<StatWidgetProps> = ({ number, label, emoji = "📊" }) => {
    return (
        <div className={styles.stat}>
            <span className={styles.statNumber}>{number}</span>
            <span className={styles.statLabel}>{label}</span>
            <span className={styles.statEmoji}>{emoji}</span>
        </div>
    );
};